import { apiRequest } from './apiService';

export const fetchDisputes = async ({ status = 'disputed' } = {}) =>
  apiRequest(`/admin/disputes?status=${encodeURIComponent(status)}&limit=200`);

export const fetchAdminOrder = async (orderId) =>
  apiRequest(`/admin/orders/${encodeURIComponent(orderId)}`);

export const releaseOrderPayout = async (orderId) =>
  apiRequest(`/admin/orders/${encodeURIComponent(orderId)}/release-payout`, {
    method: 'POST',
  });

export const refundOrder = async (orderId, reason) =>
  apiRequest(`/admin/orders/${encodeURIComponent(orderId)}/refund`, {
    method: 'POST',
    body: { reason },
  });

export const resolveDispute = async (orderId, resolution, notes) =>
  apiRequest(`/admin/orders/${encodeURIComponent(orderId)}/resolve-dispute`, {
    method: 'POST',
    body: { resolution, notes },
  });
